'use client';

// module imports
import Image from 'next/image';
import { useRef } from 'react';

interface ProfilePhotoSectionProps {
  profilePhoto: string;
  onPhotoChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function ProfilePhotoSection({ profilePhoto, onPhotoChange }: ProfilePhotoSectionProps) {
  const fileRef = useRef<HTMLInputElement>(null);

  return (
    <div className="flex flex-col items-center justify-center">
      <button className="rounded-full overflow-hidden border-4 border-white shadow-lg hover:ring-2 hover:ring-[#e92773] focus:outline-none cursor-pointer transition" title="Click to change profile image" onClick={() => fileRef.current?.click()} type="button" style={{ width: 200, height: 200 }}>
        <Image src={profilePhoto || 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_640.png'} alt="Profile" width={200} height={200} className="object-cover w-full h-full" priority />
      </button>
      <input ref={fileRef} type="file" accept="image/*" className="hidden" onChange={onPhotoChange} />
      <span className="text-pink-500 text-xs mt-2">This is clickable for Image Upload or Update</span>
    </div>
  );
}
